/* eslint max-len: 0 quote-props: 0 */

export default {
    modal: {
        'close': '閉じる',
    },
    login: {
        'loading': 'ロード中',
        'modalLabelUsername': 'ユーザー名',
        'modalLabelPassword': 'パスワード',
        'modalLabelRememberUsername': 'ユーザーを保存',
        'modalLabelKeepMeLoggedIn': 'ログインのままにする',
        'modalLoginButtonText': 'ログイン',
        'modalForgotPassword': 'ログイン情報をお忘れですか',
        'modalRegisterText': 'アカウントをまだお持ちでないですか？',
        'modalRegisterLink': '今すぐ参加',
        'modalValidatorUsernameRequired': 'ユーザー名が必要です',
        'modalValidatorUsernameFormat': 'ユーザー名は英文字、数字およびアンダースコアのみが含まれていなければなりません',
        'modalValidatorUsernameTooShort': 'ユーザー名は少なくとも6文字でなければなりません',
        'modalValidatorUsernameTooLong': 'ユーザー名は15文字を超えてはなりません',
        'modalValidatorPasswordRequired': 'パスワードが必要です',
        'modalValidatorPasswordFormat': 'パスワードは英文字、数字、アンダースコアおよびハイフンのみが含まれていなければなりません',
        'modalValidatorPasswordTooShort': 'パスワードは少なくとも6文字でなければなりません',
        'modalValidatorPasswordTooLong': 'パスワードは15文字を超えてはなりません',
        'modalErrorInitFormLine1': '何か問題が発生しているようです',
        'modalErrorInitFormLine2': '時間をおいて再度お試しください…',
        'modalErrorAuthDefaultLine1': '何か問題が発生しているようです',
        'modalErrorAuthDefaultLine2': '弊社はお客様の情報を処理することが出来ません。再度お試しください。',
        'modalErrorAuthCredentialsBadLine1': '申し訳ございませんが、お客様が入力なさったユーザー名/パスワードは間違っているようです。',
        'modalErrorAuthCredentialsBadLine2': 'もう一度お試しになるか、<RecoverAccountComponent>ここをクリック</RecoverAccountComponent> してお客様のアカウントを回復してください。',
        'modalErrorAuthSelfExcludedLine1': 'お客様は、ご自身のアカウントからの自己除外をリクエストなさいました。',
        'modalErrorAuthSelfExcludedLine2': '<a href="{showHelp__(2733)}">ここをクリック</a>して、責任あるギャンブルに関する情報をご覧ください。',
        'modalErrorAuthLockedLine1': '申し訳ございませんが、お客様のアカウントに何らかの問題があるようです。',
        'modalErrorAuthLockedLine2': '<a href="{launchLiveChat__(chat_err:++:OB_ERR_CUST_ACCT_LOCKED)}">ここをクリック</a>し、ライブチャットを通じてカスタマーサービスへご連絡ください。',
        'modalErrorAuthInactiveLine1': '申し訳ございませんが、お客様のアカウントに何らかの問題があるようです。',
        'modalErrorAuthInactiveLine2': '<a href="{showHelp__(5566)}">ここをクリック</a>して、カスタマーサービスへご連絡ください。',
        'modalErrorAuthClosedLine1': '申し訳ございませんが、お客様のアカウントにログインすることが出来ないようです。',
        'modalErrorAuthClosedLine2': '<a href="{showHelp__(5566)}">ここをクリック</a>して、カスタマーサービスへご連絡ください。',
        'modalErrorAuthAgeVerificationLine1': '申し訳ございませんが、お客様は年齢確認証明を完了なさっていないようです：',
        'modalErrorAuthAgeVerificationLine2': '<a href="{ageVerification}">ここをクリック</a>し、完了してください。',
        'modalErrorAuthClosedByPlayerLine1': '申し訳ございませんが、お客様のアカウントは閉鎖されています。',
        'modalErrorAuthClosedByPlayerLine2': '<a href="{reopenAccount}">ここをクリック</a>してお客様のアカウントを再開なさるか、  <a href="{showHelp__(5566)}">カスタマーサービスにご連絡ください</a>。',
        'modalErrorAuthSelfExcludedFinishedLine1': '自己除外がこのアカウントに適用されていますが、再開することが可能です。',
        'modalErrorAuthSelfExcludedFinishedLine2': '再開のためには<a href="{showHelp__(5566)}">ここをクリック</a>し、カスタマーサービスへご連絡ください。',
        'modalErrorAuthTimeoutLine1': 'タイムアウトを設定なさった場合、お客様のアカウントへログインすることが出来ません。お客様のタイムアウト終了日時は、{date} の {time} です。',
        'modalErrorAuthTimeoutLine2': 'この時間を過ぎると、お客様は再度アカウントにログインすることが可能になります。<a href="{showHelp__(2733)}">ここをクリック</a>して、責任あるギャンブルに関する情報をご覧ください。',
        'modalErrorAuthOxiErrorLine1': '申し訳ございませんが、ログインに何らかの問題が生じたようです。時間をおいてから、再度お試しください。',
        'modalErrorAuthOxiErrorLine2': 'もし、同じ問題が継続して起こる場合、 <a href="{showHelp__(5566)}">ここをクリック</a>して、カスタマーサービスへご連絡ください。',
        'modalErrorAuthRestrictedLine1': 'お客様のアカウントはブロックされています。',
        'modalErrorAuthRestrictedLine2': '<a href="{showHelp__(5566)}">ここをクリック</a>して、カスタマーサービスへご連絡ください。',
        'modalErrorAuthMaxLoginAttemptsLine1': 'お客様はログインにお困りのように見受けられます',
        'modalErrorAuthMaxLoginAttemptsLine2': '- <RecoverAccountComponent>ここをクリック</RecoverAccountComponent> なさり、お客様のアカウントの回復が必要です。',
        'modalErrorAuthMaxLinkedAccountsLine1': 'お客様はWilliam Hillのアカウントを既にお持ちのように見受けられます。',
        'modalErrorAuthMaxLinkedAccountsLine2': '弊社の利用規約では、お一人につき1つのアカウントのみが許可されております。お客様の既存のアカウントでログインなさるか、もしお客様がログイン情報をお忘れの場合は、<RecoverAccountComponent>ここ</RecoverAccountComponent>をクリックして再取得なさるか、弊社の<a href="{showHelp__(10298)}">カスタマーサービス</a> チーまでご連絡ください。',

    },
};



// WEBPACK FOOTER //
// ./src/main/translations/ja-jp.js